'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tag = function tag() {
  var propsToRemove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var clean = cleanProps(propsToRemove);

  return function (type) {
    var Base = function Base(props) {
      var isEl = typeof type === 'string';
      var Comp = isEl ? props.is || type : type;
      var next = isEl ? clean(props) : props;

      if (isEl) next.is = null;

      return _react2.default.createElement(Comp, next);
    };

    return Base;
  };
};

var cleanProps = exports.cleanProps = function cleanProps(keys) {
  var dict = keys.reduce(function (a, key) {
    return Object.assign(a, _defineProperty({}, key, true));
  }, {});

  return function (props) {
    var next = {};
    for (var key in props) {
      if (dict[key]) continue;
      next[key] = props[key];
    }
    return next;
  };
};

exports.default = tag;


//////////////////
// WEBPACK FOOTER
// ./~/tag-hoc/dist/tag.js
// module id = 301
// module chunks = 0